/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Form } from 'react-final-form';
import { PrimaryButton, SecondaryButton } from '../../../../core/components/button';
import { TextInputField, FormErrors } from '../../../../core/components/form';

export interface ChangePasswordFormModel {
  password: string;
  new_password: string;
  confirm_new_password: string;
}

export interface ChangePasswordFormProps {
  onSubmit(model: ChangePasswordFormModel): void;
  isSubmitting: boolean;
  onCancel(): void;
  hideCancelBtn: boolean;
}

const formValidation = (data: ChangePasswordFormModel): FormErrors<ChangePasswordFormModel> => {
  const errors: FormErrors<ChangePasswordFormModel> = {};
  if (!data.password) {
    errors.password = 'Current password is required';
  }

  if (!data.new_password) {
    errors.new_password = 'New password is required';
  }

  if (data.password === data.new_password) {
    errors.new_password = 'New password has to be different from the old password';
  }

  if (!data.confirm_new_password) {
    errors.confirm_new_password = 'New password confirmation is required';
    return errors;
  }

  if (data.new_password !== data.confirm_new_password) {
    errors.confirm_new_password = 'New password and password confirmation do not match';
  }

  return errors;
};

export const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({
  onSubmit,
  isSubmitting,
  onCancel,
  hideCancelBtn,
}: ChangePasswordFormProps): React.ReactElement => {
  const onCancelClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onCancel();
  };
  return (
    <Form
      onSubmit={onSubmit}
      validate={formValidation}
      render={({ handleSubmit, valid }) => (
        <form onSubmit={handleSubmit}>
          <TextInputField
            type="password"
            name="password"
            placeholder="Enter Current Password"
            label="Current password"
          />
          <TextInputField type="password" name="new_password" placeholder="Enter new password" label="New password" />
          <TextInputField
            type="password"
            name="confirm_new_password"
            placeholder="Repeat new password"
            label="Repeat the new password"
          />
          <div className="mt-4 d-flex justify-content-end">
            {!hideCancelBtn && (
              <SecondaryButton className="me-3" onClick={onCancelClickHandler}>
                Cancel
              </SecondaryButton>
            )}
            <PrimaryButton type="submit" onClick={handleSubmit} isLoading={isSubmitting} isDisabled={!valid}>
              {isSubmitting ? 'Changing password...' : 'Change password'}
            </PrimaryButton>
          </div>
        </form>
      )}
    />
  );
};
